module.exports = __webpack_public_path__ + "img/Smart-Point-Girona_logo.e351d4e7.png";